<script setup lang="ts">
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import Alert from '@/components/Elements/Alerts/Alert.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import { handleNext } from '../tutorialSteps'
import GenericIcon from '@/components/Elements/Images/Icons/GenericIcon.vue'

const handleNextStep = async () => {
  await handleNext('tutorial_resources_usages')
}
</script>

<template>
  <TutorialFrame 
    video-url="https://cdn.ferion.com/videos/advisors/temperate/resources.webm"
  >
    <template #text>
      <p class="pb-2">
        What can we use all these ore's and materials for?
      </p>
      <p class="pb-2">
        Large projects like terraformers, dyson swarms and ringworlds give your empire huge boosts in productivity.
      </p>
      <p class="pb-2">
        Often these projects require multiple amounts of certain ores which take time to mine and process.
      </p>
      <p class="pb-2">
        Plan your resource production based on your long-term goals. Building the right refineries early will pay dividends later!
      </p>
    </template>

    <template #alerts>
      <Alert type="info">
        Look around what projects are available and what ores are required.
      </Alert>
    </template>

    <template #buttons>
      <ActionButton @click="handleNextStep">
        Gotcha!
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss">

</style>